<!--
 * @Author: your name
 * @Date: 2021-07-22 17:22:20
 * @LastEditTime: 2021-07-22 17:30:45
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \newBj-admin\src\views\center-setting\indexes\inquiry\edit.vue
-->
<template>
  <inquiry-operate />
</template>
<script>
import inquiryOperate from './components/inquiryOperate';
export default {
  name: 'SettingInquiryEdit',
  components: {
    inquiryOperate,
  },
  data() {
    return {};
  },
};
</script>
